import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__feeds_latest',
    path: '/latest/',
    component: () =>
      interopDefault(
        import('~/pages/latest.vue' /* webpackChunkName: "pages-latest" */)
      )
  }
]
